// src/belediye/components/mesajlasma/SihirbazAltSatir.js
// FAZ-83 — SİHİRBAZIN TEK ALT SATIRI = ANA MESAJ KUTUSU.
//
// NEDEN AYRI BİR BİLEŞEN: bu satır bugüne kadar BEŞ ayrı dosyada tek tek
// yazılıydı (DuePicker, MahallePicker, KonumSecici, EkSecici, WizardQuestion).
// Aynı düzeltmeyi beş kez yazmak, birini unutmak demek.
//
// FAZ-83/2 (kullanıcı, 2026-08-01) — "ANA MESAJ KUTUSUNU KULLAN":
//   "sen yine ana mesaj kutusunu boşa yazmışsın, burada bunu kullanalım…
//    gidip yeniden bir alan oluşturma."
// Yani hiçbir adım kendine AYRI bir giriş kutusu açmaz. Başlık da, açıklama
// da, mahalle araması da, adres de, süre özeti de HEP BU SATIRIN İÇİNDE olur.
// Adımdan adıma değişen tek şey satırın ORTASINDAKİ içerik.
//
// Yerleşim (soldan sağa):
//   [ Atla ]  [ ——— ortadaki içerik: kutu / çipler / özet ——— ]  [ ➤ ]
//
// FAZ-83/B1 — ATLA SOLDA, GÖNDER SAĞDA. İkisi de satırın SAĞ ucunda yan yana
// duruyordu; parmak ~9 mm, aralarındaki boşluk ~2 mm idi. Yanlışlıkla Atla'ya
// basmak doldurulan alanı boş geçiriyordu.
// FAZ-83/2: Atla artık ÇERÇEVELİ bir çip (kullanıcı: "bunu da bir çerçeve
// içine al, sadece yazı olmasın") ve yazılan yazı ONDAN SONRA başlar.
import React from "react";
import { PaperAirplaneIcon } from "@heroicons/react/24/outline";

export default function SihirbazAltSatir({
  // SOL UÇ — atlama/vazgeçme. Verilmezse sol uç boş kalır.
  onSkip,
  skipEtiket = "Atla",
  skipTitle,
  // Sol uçta, Atla'dan ÖNCE ek düğme(ler) — ör. süre panelindeki
  // "Süreyi kaldır" çipi. Nadiren kullanılır.
  sol = null,
  // ORTA — satırın içine giren asıl içerik (mesaj kutusu, mahalle çipleri…).
  // Yoksa yalnız `ozet` yazısı görünür (ORTALANMIŞ).
  children = null,
  ozet = null,
  // SAĞ UÇ — ilerletme.
  onGonder,
  gonderAktif = true,
  gonderTitle = "Devam et",
  pasif = false,
  sinif = "",
}) {
  return (
    <div className={`msj-composer msj-wq-composer msj-alt ${sinif}`.trim()}>
      {sol}
      {onSkip && (
        <button
          type="button"
          className="msj-wq-skip msj-atla"
          onClick={onSkip}
          title={skipTitle || skipEtiket}
          disabled={pasif}
        >
          {skipEtiket}
        </button>
      )}
      <div className="msj-alt-icerik">
        {children}
        {ozet != null && <span className="msj-alt-ozet">{ozet}</span>}
      </div>
      <button
        type="button"
        className="msj-sendbtn"
        disabled={pasif || !gonderAktif}
        onClick={onGonder}
        title={gonderTitle}
        aria-label={gonderTitle}
      >
        <PaperAirplaneIcon />
      </button>
    </div>
  );
}
